<template>
  <v-container>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel
        v-for="item in groupedNotifications"
        :key="item.bill.ID"
      >
        <v-expansion-panel-header>
          <h3 :class="item.unread > 0 ? 'primary--text' : 'grey--text'">
            {{ item.bill.BillNumber }} - {{ item.bill.ShortTitle }}
            <v-badge
              overlap
              v-if="item.unread > 0"
              class="ml-2"
              :content="item.unread"
            >
              <v-btn color="primary" outlined :to="`/bill/${item.bill.ID}`">
                Open Bill</v-btn
              >
            </v-badge>
            <v-btn
              class="ml-3"
              v-else
              color="primary lighten-2"
              outlined
              :to="`/bill/${item.bill.ID}`"
            >
              Open Bill</v-btn
            >
          </h3>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-list-item-action> </v-list-item-action>

          <TrackedBillNotifications
            :billNotifications="item.notifications"
          ></TrackedBillNotifications>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBillNotifications from '@components/notifications/TrackedBillNotifications'
export default {
  page: {
    title: '',
  },
  //model: {
  //	prop: ''
  //},
  props: {},
  components: { TrackedBillNotifications },
  filters: {},
  data() {
    return {
      panel: [],
    }
  },
  created() {
    this.loadNotifications()
    this.panel = this.groupedNotifications.map((v, i) =>
      v.unread > 0 ? i : null
    )
  },
  computed: {
    ...get('notification', ['notifications', 'hasUnacknowledged', 'loading']),
    groupedNotifications: {
      get() {
        var grouped = this.notifications.reduce(
          (r, v, i, a, k = v.TrackedBillID) => {
            r[k] = r[k] || { notifications: [] }
            r[k].notifications.push(v)
            return r
          },
          {}
        )
        var arrayGroup = []
        for (const [key, value] of Object.entries(grouped)) {
          value.notifications.sort((a, b) => {
            return a.IsAcknowledged == b.IsAcknowledged
              ? new Date(a.CreatedDate) < new Date(b.CreatedDate)
                ? 1
                : -1
              : a.IsAcknowledged
              ? 1
              : -1
          })
          value.unread = value.notifications.filter(
            (n) => !n.IsAcknowledged
          ).length
          value.bill = value.notifications[0].TrackedBill
          arrayGroup.push(value)
        }
        return arrayGroup.sort((a, b) => {
          return new Date(a.notifications[0].CreatedDate) <
            new Date(b.notifications[0].CreatedDate)
            ? 1
            : -1
        })
      },
      set(value) {},
    },
  },
  methods: {
    ...call('notification', ['loadNotifications']),
  },
  watch: {
    notifications(nval, oval) {
      if (this.groupedNotifications.length != this.panel.length) {
        this.panel = this.groupedNotifications.map((v, i) =>
          v.unread > 0 ? i : null
        )
      }
    },
  },
}
</script>
<style scoped>
</style>